module.exports = __webpack_public_path__ + "img/today_52px.314b10eb.png";